export class Address {
    street?: string;
    city?: string;
    state?: string;
    country?: string;
    timeZone?: string;
    locale?: string;
    postal?: string;

    public load(data: any): Address {
        Object.assign(this, data);

        return this;
    }

    public getStreetAddress(): string {
        let streetAddress = '';

        if (this.street){
            streetAddress += this.street;
        }

        if (this.city){
            if (streetAddress.length > 0){
                streetAddress += ', ';
            }

            streetAddress += this.city;
        }

        if (this.state){
            if (streetAddress.length > 0){
                streetAddress += ', ';
            }

            streetAddress += this.state;
        }

        return streetAddress;
    }

    public getFullAddress(): string {
        let streetAddress = this.getStreetAddress();

        if (this.country){
            if (streetAddress.length > 0){
                streetAddress += ', ';
            }

            streetAddress += this.country;
        }

        if (this.timeZone){
            if (streetAddress.length > 0){
                streetAddress += ' ';
            }

            streetAddress += '(' + this.timeZone + ')';
        }

        return streetAddress;
    }
}
